import { createFileRoute } from "@tanstack/react-router";

import { useMe } from "../features/auth/session";
import { mayManage } from "../features/autopilot/labels";
import { CampaignPolicy } from "../features/autopilot/CampaignPolicy";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/campaigns/$campaignId/policy")({
  component: TabRoute,
});

function TabRoute() {
  const t = useT();
  const me = useMe();
  const { campaignId } = Route.useParams();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return <CampaignPolicy campaignId={campaignId} mayManage={mayManage(me.data)} />;
}
